module.exports = __webpack_public_path__ + "img/cn_map.8531e906.png";